export default ({app}, inject) => {
  inject('validate', (payload, schema) => schema.validate(payload, {allowUnknown: true, abortEarly: false}));
}
